// Enums para coincidir con el backend
export enum Difficulty {
    FÁCIL = 'FÁCIL',
    MEDIO = 'MEDIO',
    DIFÍCIL = 'DIFÍCIL'
}

export enum MealCategory {
    DESAYUNO = 'DESAYUNO',
    COMIDA = 'COMIDA',
    CENA = 'CENA',
    SNACK = 'SNACK'
}

export enum MealType {
    DESAYUNO = 'DESAYUNO',
    COMIDA = 'COMIDA',
    CENA = 'CENA',
    SNACK = 'SNACK'
}

export enum Tag {
    VEGETARIANA = 'VEGETARIANA',
    VEGANA = 'VEGANA',
    ALTA_PROTEINA = 'ALTA_PROTEINA',
    BAJO_EN_CARBOS = 'BAJO_EN_CARBOS',
    GLUTEN_FREE = 'GLUTEN_FREE',
    SIN_LACTOSA = 'SIN_LACTOSA',
    RÁPIDA = 'RÁPIDA',
    KETO = 'KETO',
    ALTA_FIBRA = 'ALTA_FIBRA',
    BAJO_EN_GRASAS = 'BAJO_EN_GRASAS',
    BAJO_EN_CALORIAS = 'BAJO_EN_CALORIAS'
}

export enum WeightGoal {
    LOSE = 'LOSE',
    MAINTAIN = 'MAINTAIN',
    GAIN = 'GAIN'
}

export enum DayOfWeek {
    LUNES = 'LUNES',
    MARTES = 'MARTES',
    MIERCOLES = 'MIÉRCOLES',
    JUEVES = 'JUEVES',
    VIERNES = 'VIERNES',
    SABADO = 'SÁBADO',
    DOMINGO = 'DOMINGO'
}

// Interfaces principales
export interface User {
    id: number;
    username: string;
    email: string;
    dietaryPreferences?: Tag[];
    excludedIngredients?: string[];

    // NUEVAS PROPIEDADES para el sistema de recomendaciones
    allergies?: string[];
    dislikedIngredients?: string[];
    nutritionalPreferences?: Tag[];
    weightGoal?: WeightGoal;

    // Propiedades para cálculo de calorías
    age?: number;
    height?: number;
    weight?: number;
    gender?: string;
    activityLevel?: string;
    recommendedCalories?: number;
}
export interface Recipe {
    id: number;
    title: string;
    time: string;
    difficulty: Difficulty;
    image?: string;
    category: MealCategory;
    calories: number;
    protein: number;
    carbs: number;
    fat: number;
    tags: Tag[];
    ingredients: string[];
    instructions?: string;
    isPublic?: boolean;
    createdBy?: User;
}

export interface DayMeals {
    desayuno: Recipe[];
    comida: Recipe[];
    cena: Recipe[];
    snack: Recipe[];
}

export interface MealPlan {
    Lunes: DayMeals;
    Martes: DayMeals;
    Miércoles: DayMeals;
    Jueves: DayMeals;
    Viernes: DayMeals;
    Sábado: DayMeals;
    Domingo: DayMeals;
}

// Request DTOs
// Request DTOs - ACTUALIZAR RegisterRequest
export interface RegisterRequest {
    username: string;
    email: string;
    password: string;
    dietaryPreferences?: Tag[];
    excludedIngredients?: string[];
    // Opcional: agregar nuevas propiedades si quieres capturarlas en registro
    allergies?: string[];
    dislikedIngredients?: string[];
    nutritionalPreferences?: Tag[];
    weightGoal?: WeightGoal;
}

export interface LoginRequest {
    username: string;
    password: string;
}

export interface RecipeRequest {
    title: string;
    time: string;
    difficulty: Difficulty;
    image?: string;
    category: MealCategory;
    calories: number;
    protein: number;
    carbs: number;
    fat: number;
    tags?: Tag[];
    ingredients?: string[];
    instructions?: string;
    isPublic?: boolean;
}

// Response DTOs
export interface AuthResponse {
    token: string;
    type: string;
    id: number;
    username: string;
    email: string;
}

export interface RecipeResponse {
    id: number;
    title: string;
    time: string;
    difficulty: Difficulty;
    image?: string;
    category: MealCategory;
    calories: number;
    protein: number;
    carbs: number;
    fat: number;
    tags: Tag[];
    ingredients: string[];
    instructions?: string;
    isPublic?: boolean;
    createdBy?: User;
}

export interface FeaturedRecipesProps {
    recipes?: Recipe[];
    onRecipeClick?: (recipe: Recipe) => void;
}

// Para manejar estados de carga
export interface ApiState<T> {
    data: T | null;
    loading: boolean;
    error: string | null;
}

export interface WeeklyMenuResponse {
    id: number;
    weekStartDate: string;
    user: UserResponse;
    dayMeals: {
        [day: string]: {
            [mealType: string]: RecipeResponse[];
        };
    };
}

export interface DayMealsResponse {
    desayuno: RecipeResponse[];
    comida: RecipeResponse[];
    cena: RecipeResponse[];
    snack: RecipeResponse[];
}

// Agregar UserResponse si no existe
// ACTUALIZAR UserResponse para incluir todas las propiedades
export interface UserResponse {
    id: number;
    username: string;
    email: string;
    dietaryPreferences?: Tag[];
    excludedIngredients?: string[];
    allergies?: string[];
    dislikedIngredients?: string[];
    nutritionalPreferences?: Tag[];
    weightGoal?: WeightGoal;
    age?: number;
    height?: number;
    weight?: number;
    gender?: string;
    activityLevel?: string;
    recommendedCalories?: number;
}


export interface FeaturedRecipesProps {
    recipes?: Recipe[];
    onRecipeClick?: (recipe: Recipe) => void;
}

// Para manejar estados de carga
export interface ApiState<T> {
    data: T | null;
    loading: boolean;
    error: string | null;
}

// Agregar RecipeResponse si no existe (completo)
export interface RecipeResponse {
    id: number;
    title: string;
    time: string;
    difficulty: Difficulty;
    image?: string;
    category: MealCategory;
    calories: number;
    protein: number;
    carbs: number;
    fat: number;
    tags: Tag[];
    ingredients: string[];
    instructions?: string;
    isPublic?: boolean;
    createdBy?: UserResponse;
}

// Agregar estas interfaces si no existen
export interface MealPlan {
    Lunes: DayMeals;
    Martes: DayMeals;
    Miércoles: DayMeals;
    Jueves: DayMeals;
    Viernes: DayMeals;
    Sábado: DayMeals;
    Domingo: DayMeals;
}

export interface DayMeals {
    desayuno: Recipe[];
    comida: Recipe[];
    cena: Recipe[];
    snack: Recipe[];
}